module.exports = __webpack_public_path__ + "static/media/citadel-dropdown.7890d449.jpg";